(() => {
  const initialize = () => {
    document.querySelectorAll('[data-pil-voc]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const tablist = root.querySelector('[role="tablist"]');
      const tabs = [...tablist.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('.pil-voc__panel')];
      const mobile = window.matchMedia('(max-width: 767px)');
      let selected = 0;
      const update = () => {
        tablist.hidden = !mobile.matches;
        tabs.forEach((tab, index) => {
          tab.setAttribute('aria-selected', String(index === selected));
          tab.tabIndex = index === selected ? 0 : -1;
          panels[index].hidden = mobile.matches && index !== selected;
          panels[index].setAttribute('role', mobile.matches ? 'tabpanel' : 'region');
          panels[index].setAttribute('aria-labelledby', mobile.matches ? tab.id : `pil-voc-heading-${index}`);
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => { selected = index; update(); });
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); selected = next; update(); tabs[next].focus();
        });
      });
      mobile.addEventListener('change', update);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
